function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Responsible for reading and writing documents which describe sticky bucket assignments.
 */
export var StickyBucketService = /*#__PURE__*/function () {
  function StickyBucketService(opts) {
    _classCallCheck(this, StickyBucketService);
    opts = opts || {};
    this.prefix = opts.prefix || "";
  }
  /**
   * The SDK calls getAllAssignments to populate sticky buckets. This in turn will
   * typically loop through individual getAssignments calls. However, some StickyBucketService
   * instances (i.e. Redis) will instead perform a multi-query inside getAllAssignments instead.
   */
  return _createClass(StickyBucketService, [{
    key: "getAllAssignments",
    value: (function () {
      var _getAllAssignments = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(attributes) {
        var _this = this;
        var docs;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              docs = {};
              _context.next = 3;
              return Promise.all(Object.entries(attributes).map(function (_ref) {
                var _ref6 = _slicedToArray(_ref, 2),
                  attributeName = _ref6[0],
                  attributeValue = _ref6[1];
                return _this.getAssignments(attributeName, attributeValue);
              }));
            case 3:
              _context.sent.forEach(function (doc) {
                if (doc) {
                  var key = "".concat(doc.attributeName, "||").concat(doc.attributeValue);
                  docs[key] = doc;
                }
              });
              return _context.abrupt("return", docs);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getAllAssignments(_x) {
        return _getAllAssignments.apply(this, arguments);
      }
      return getAllAssignments;
    }())
  }, {
    key: "getKey",
    value: function getKey(attributeName, attributeValue) {
      return "".concat(this.prefix).concat(attributeName, "||").concat(attributeValue);
    }
  }]);
}();
export var LocalStorageStickyBucketService = /*#__PURE__*/function (_StickyBucketService) {
  function LocalStorageStickyBucketService(opts) {
    var _this2;
    _classCallCheck(this, LocalStorageStickyBucketService);
    opts = opts || {};
    _this2 = _callSuper(this, LocalStorageStickyBucketService);
    _this2.prefix = opts.prefix || "gbStickyBuckets__";
    try {
      _this2.localStorage = opts.localStorage || globalThis.localStorage;
    } catch (e) {
      // Ignore localStorage errors
    }
    return _this2;
  }
  _inherits(LocalStorageStickyBucketService, _StickyBucketService);
  return _createClass(LocalStorageStickyBucketService, [{
    key: "getAssignments",
    value: function () {
      var _getAssignments = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(attributeName, attributeValue) {
        var key, doc, raw, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              key = this.getKey(attributeName, attributeValue);
              doc = null;
              if (this.localStorage) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return", doc);
            case 4:
              _context2.prev = 4;
              _context2.next = 7;
              return this.localStorage.getItem(key);
            case 7:
              _context2.t0 = _context2.sent;
              if (_context2.t0) {
                _context2.next = 10;
                break;
              }
              _context2.t0 = "{}";
            case 10:
              raw = _context2.t0;
              data = JSON.parse(raw);
              if (data.attributeName && data.attributeValue && data.assignments) {
                doc = data;
              }
              _context2.next = 17;
              break;
            case 15:
              _context2.prev = 15;
              _context2.t1 = _context2["catch"](4);
            case 17:
              return _context2.abrupt("return", doc);
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 15]]);
      }));
      function getAssignments(_x2, _x3) {
        return _getAssignments.apply(this, arguments);
      }
      return getAssignments;
    }()
  }, {
    key: "saveAssignments",
    value: function () {
      var _saveAssignments = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(doc) {
        var key;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              key = this.getKey(doc.attributeName, doc.attributeValue);
              if (this.localStorage) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              _context3.prev = 3;
              _context3.next = 6;
              return this.localStorage.setItem(key, JSON.stringify(doc));
            case 6:
              _context3.next = 10;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](3);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[3, 8]]);
      }));
      function saveAssignments(_x4) {
        return _saveAssignments.apply(this, arguments);
      }
      return saveAssignments;
    }()
  }]);
}(StickyBucketService);
export var ExpressCookieStickyBucketService = /*#__PURE__*/function (_StickyBucketService2) {
  /**
   * Intended to be used with cookieParser() middleware from npm: 'cookie-parser'.
   * Assumes:
   *  - reading a cookie is automatically decoded via decodeURIComponent() or similar
   *  - writing a cookie name & value must be manually encoded via encodeURIComponent() or similar
   *  - all cookie bodies are JSON encoded strings and are manually encoded/decoded
   */

  function ExpressCookieStickyBucketService(_ref2) {
    var _this3;
    _classCallCheck(this, ExpressCookieStickyBucketService);
    var _ref2$prefix = _ref2.prefix,
      prefix = _ref2$prefix === void 0 ? "gbStickyBuckets__" : _ref2$prefix,
      req = _ref2.req,
      res = _ref2.res,
      _ref2$cookieAttribute = _ref2.cookieAttributes,
      cookieAttributes = _ref2$cookieAttribute === void 0 ? {
        maxAge: 180 * 24 * 3600 * 1000
      } : _ref2$cookieAttribute;
    _this3 = _callSuper(this, ExpressCookieStickyBucketService);
    _this3.prefix = prefix;
    _this3.req = req;
    _this3.res = res;
    _this3.cookieAttributes = cookieAttributes;
    return _this3;
  }
  _inherits(ExpressCookieStickyBucketService, _StickyBucketService2);
  return _createClass(ExpressCookieStickyBucketService, [{
    key: "getAssignments",
    value: function () {
      var _getAssignments2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(attributeName, attributeValue) {
        var key, doc, raw, data;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              key = this.getKey(attributeName, attributeValue);
              doc = null;
              if (this.req) {
                _context4.next = 4;
                break;
              }
              return _context4.abrupt("return", doc);
            case 4:
              try {
                raw = this.req.cookies[key] || "{}";
                data = JSON.parse(raw);
                if (data.attributeName && data.attributeValue && data.assignments) {
                  doc = data;
                }
              } catch (e) {
                // Ignore cookie errors
              }
              return _context4.abrupt("return", doc);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getAssignments(_x5, _x6) {
        return _getAssignments2.apply(this, arguments);
      }
      return getAssignments;
    }()
  }, {
    key: "saveAssignments",
    value: function () {
      var _saveAssignments2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(doc) {
        var key, str;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              key = this.getKey(doc.attributeName, doc.attributeValue);
              if (this.res) {
                _context5.next = 3;
                break;
              }
              return _context5.abrupt("return");
            case 3:
              str = JSON.stringify(doc);
              this.res.cookie(encodeURIComponent(key), encodeURIComponent(str), this.cookieAttributes);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function saveAssignments(_x7) {
        return _saveAssignments2.apply(this, arguments);
      }
      return saveAssignments;
    }()
  }]);
}(StickyBucketService);
export var BrowserCookieStickyBucketService = /*#__PURE__*/function (_StickyBucketService3) {
  /**
   * Intended to be used with npm: 'js-cookie'.
   * Assumes:
   *  - reading a cookie is automatically decoded via decodeURIComponent() or similar
   *  - writing a cookie name & value is automatically encoded via encodeURIComponent() or similar
   *  - all cookie bodies are JSON encoded strings and are manually encoded/decoded
   */

  function BrowserCookieStickyBucketService(_ref3) {
    var _this4;
    _classCallCheck(this, BrowserCookieStickyBucketService);
    var _ref3$prefix = _ref3.prefix,
      prefix = _ref3$prefix === void 0 ? "gbStickyBuckets__" : _ref3$prefix,
      jsCookie = _ref3.jsCookie,
      _ref3$cookieAttribute = _ref3.cookieAttributes,
      cookieAttributes = _ref3$cookieAttribute === void 0 ? {
        expires: 180
      } : _ref3$cookieAttribute;
    _this4 = _callSuper(this, BrowserCookieStickyBucketService);
    _this4.prefix = prefix;
    _this4.jsCookie = jsCookie;
    _this4.cookieAttributes = cookieAttributes;
    return _this4;
  }
  _inherits(BrowserCookieStickyBucketService, _StickyBucketService3);
  return _createClass(BrowserCookieStickyBucketService, [{
    key: "getAssignments",
    value: function () {
      var _getAssignments3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(attributeName, attributeValue) {
        var key, doc, raw, data;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              key = this.getKey(attributeName, attributeValue);
              doc = null;
              if (this.jsCookie) {
                _context6.next = 4;
                break;
              }
              return _context6.abrupt("return", doc);
            case 4:
              try {
                raw = this.jsCookie.get(key);
                data = JSON.parse(raw || "{}");
                if (data.attributeName && data.attributeValue && data.assignments) {
                  doc = data;
                }
              } catch (e) {
                // Ignore cookie errors
              }
              return _context6.abrupt("return", doc);
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getAssignments(_x8, _x9) {
        return _getAssignments3.apply(this, arguments);
      }
      return getAssignments;
    }()
  }, {
    key: "saveAssignments",
    value: function () {
      var _saveAssignments3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(doc) {
        var key, str;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              key = this.getKey(doc.attributeName, doc.attributeValue);
              if (this.jsCookie) {
                _context7.next = 3;
                break;
              }
              return _context7.abrupt("return");
            case 3:
              str = JSON.stringify(doc);
              this.jsCookie.set(key, str, this.cookieAttributes);
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function saveAssignments(_x10) {
        return _saveAssignments3.apply(this, arguments);
      }
      return saveAssignments;
    }()
  }]);
}(StickyBucketService);
export var RedisStickyBucketService = /*#__PURE__*/function (_StickyBucketService4) {
  /** Intended to be used with npm: 'ioredis'. **/

  function RedisStickyBucketService(_ref4) {
    var _this5;
    _classCallCheck(this, RedisStickyBucketService);
    var redis = _ref4.redis;
    _this5 = _callSuper(this, RedisStickyBucketService);
    _this5.redis = redis;
    return _this5;
  }
  _inherits(RedisStickyBucketService, _StickyBucketService4);
  return _createClass(RedisStickyBucketService, [{
    key: "getAllAssignments",
    value: function () {
      var _getAllAssignments2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(attributes) {
        var _this6 = this,
          _this$redis;
        var docs, keys;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              docs = {};
              keys = Object.entries(attributes).map(function (_ref5) {
                var _ref7 = _slicedToArray(_ref5, 2),
                  attributeName = _ref7[0],
                  attributeValue = _ref7[1];
                return _this6.getKey(attributeName, attributeValue);
              });
              if (this.redis) {
                _context8.next = 4;
                break;
              }
              return _context8.abrupt("return", docs);
            case 4:
              _context8.next = 6;
              return (_this$redis = this.redis).mget.apply(_this$redis, _toConsumableArray(keys)).then(function (values) {
                values.forEach(function (raw) {
                  try {
                    var data = JSON.parse(raw || "{}");
                    if (data.attributeName && data.attributeValue && data.assignments) {
                      var key = "".concat(data.attributeName, "||").concat(data.attributeValue);
                      docs[key] = data;
                    }
                  } catch (e) {
                    // ignore redis doc parse errors
                  }
                });
              });
            case 6:
              return _context8.abrupt("return", docs);
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getAllAssignments(_x11) {
        return _getAllAssignments2.apply(this, arguments);
      }
      return getAllAssignments;
    }()
  }, {
    key: "getAssignments",
    value: function () {
      var _getAssignments4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(_attributeName, _attributeValue) {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", null);
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      function getAssignments(_x12, _x13) {
        return _getAssignments4.apply(this, arguments);
      }
      return getAssignments;
    }()
  }, {
    key: "saveAssignments",
    value: function () {
      var _saveAssignments4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(doc) {
        var key;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              key = this.getKey(doc.attributeName, doc.attributeValue);
              if (this.redis) {
                _context10.next = 3;
                break;
              }
              return _context10.abrupt("return");
            case 3:
              _context10.next = 5;
              return this.redis.set(key, JSON.stringify(doc));
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function saveAssignments(_x14) {
        return _saveAssignments4.apply(this, arguments);
      }
      return saveAssignments;
    }()
  }]);
}(StickyBucketService);